import { createSlice } from "@reduxjs/toolkit";

const breadcrumbsSlice = createSlice({
  name: "breadcrumbs",
  initialState: {
    breadcrumbDynamicPathNames: [], // Array to hold multiple dynamic breadcrumbs
    breadcrumbDynamicID: [], // Array to hold multiple dynamic breadcrumbs
  },
  reducers: {
    setBreadcrumbDynamicPathNames: (state, action) => {
      state.breadcrumbDynamicPathNames = action.payload; // Expecting an array
    },
    resetBreadcrumbs: (state) => {
      state.breadcrumbDynamicPathNames = [];
    },
    setBreadcrumbDynamicID: (state, action) => {
      state.breadcrumbDynamicID = action.payload; // Expecting an array
    },
  },
});

export const {
  setBreadcrumbDynamicPathNames,
  addBreadcrumbDynamicPathName,
  resetBreadcrumbs,
  setBreadcrumbDynamicID,
} = breadcrumbsSlice.actions;

export default breadcrumbsSlice.reducer;
